export default function slidersInit() {

	(function ($) {

		$('#cs-photos__slider').slick({
			dots: false,
			infinite: true,
			slidesToShow: 1,
			autoplay: true,
			speed: 1200,
		});

		$('#cs-description__tabs, .cs-heading__media-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {

			if (currentSlide == nextSlide) return;

			var current = $(slick.$slides.get(currentSlide));
			var next;
			if ((nextSlide < currentSlide && (currentSlide === 1 && nextSlide !== 0)) || (currentSlide === 0 && nextSlide === slick.slideCount - 1)) {
				next = current.prev();
			}
			else {
				next = current.next();
			}

			if (next.hasClass('slick-cloned')) {
				next.addClass('slick-clone-current');
			}
		});

		$('#cs-description__tabs').on('afterChange', function () {
			$('#cs-description__tabs .slick-clone-current').removeClass('slick-clone-current');
		});


		$('#cs-description__tabs').slick({
			// initialSlide: 1,
			autoplay: false,
			infinite: true,
			focusOnSelect: true,
			speed: 800,
			waitForAnimate: false
		});

		$('.cs-heading__media-slider').slick({
			dots: true,
			arrows: true
		});

		$('#cs-description__tabs').on('click', '[data-next-slide]', function (e) {
			$('#cs-description__tabs').slick('slickNext');
		});

	})(jQuery);

}
